import { marker } from '@ngneat/transloco-keys-manager/marker';

import { sharedI18nKeys } from '@cjm/shared/i18n';
import { I18nKeys as formI18nKeys } from '@cjm/shared/ui/forms';

export const I18nKeys = {
	...sharedI18nKeys,
	...formI18nKeys,
	Home: {
		Header: {
			Title: {
				withName: marker('home.header.title.with-name'),
				withoutName: marker('home.header.title.without-name')
			},
			Intro: marker('home.header.intro'),
			Search: {
				Placeholder: marker('home.header.search.placeholder')
			},
			Links: {
				Offers: {
					Urls: {
						AdviceAndGuidance: marker('home.header.links.offers.urls.advice-and-guidance'),
						Evidence: marker('home.header.links.offers.urls.evidence'),
						FinancialAdvantage: marker('home.header.links.offers.urls.financial-advantage'),
						FinancialObligation: marker('home.header.links.offers.urls.financial-obligation'),
						InfrastructureAndMaterial: marker('home.header.links.offers.urls.infrastructure-and-material'),
						Admission: marker('home.header.links.offers.urls.admission')
					},
					BlockLink: marker('home.header.links.offers.block-link'),
					QueryParam: marker('home.header.links.offers.queryparam')
				},
				Associations: {
					Urls: {
						NeighborhoodOperationAndCommittee: marker(
							'home.header.links.associations.urls.neighborhood-operation-and-committee'
						),
						HealthAndWelfare: marker('home.header.links.associations.urls.health-and-welfare'),
						YouthWork: marker('home.header.links.associations.urls.youth-work'),
						ArtsHeritageAndCulture: marker('home.header.links.associations.urls.arts-heritage-and-culture'),
						Education: marker('home.header.links.associations.urls.education'),
						Sport: marker('home.header.links.associations.urls.sport')
					},
					BlockLink: marker('home.header.links.associations.block-link'),
					MyAssociationLink: marker('home.header.links.associations.my-association-link'),
					QueryParam: marker('home.header.links.associations.queryparam')
				}
			}
		},
		WeGrowTogetherSection: {
			Title: marker('home.we-grow-together-section.title'),
			Text: marker('home.we-grow-together-section.text'),
			Button: {
				Text: marker('home.we-grow-together-section.button.text'),
				Title: marker('home.we-grow-together-section.button.title')
			}
		},
		AssociationPassportSection: {
			Titles: {
				DefaultTitle: marker('home.association-passport-section.titles.default-title'),
				CompletePassportTitle: marker('home.association-passport-section.titles.complete-passport-title'),
				CompletedPassportTitle: marker('home.association-passport-section.titles.completed-passport-title')
			},
			Subtitles: {
				DefaultSubtitle: marker('home.association-passport-section.subtitles.default-subtitle')
			},
			CompletedText: marker('home.association-passport-section.completed-text'),
			DefaultList: marker('home.association-passport-section.default-list'),
			RegisterButton: {
				Text: marker('home.association-passport-section.register-button.text'),
				Title: marker('home.association-passport-section.register-button.title')
			},
			MyAssociationButton: {
				Text: marker('home.association-passport-section.my-association-button.text'),
				Title: marker('home.association-passport-section.my-association-button.title')
			}
		},
		InTheSpotlight: {
			Title: marker('home.in-the-spotlight.title')
		},
		AdviceForAssociations: {
			Title: marker('home.advice-for-associations.title'),
			Text: marker('home.advice-for-associations.text'),
			MoreAdviceButton: {
				Text: marker('home.advice-for-associations.more-advice-button.text'),
				Title: marker('home.advice-for-associations.more-advice-button.title')
			}
		},
		AboutUsSection: {
			Title: marker('home.about-us-section.title'),
			Text: marker('home.about-us-section.text'),
			LinkAccessibilityText: marker('home.about-us-section.link-accessibility-text'),
			Cards: {
				LinkYourServicesAndInformation: {
					CardTitle: marker('home.about-us-section.cards.link-your-services-and-information.card-title'),
					CardDescription: marker(
						'home.about-us-section.cards.link-your-services-and-information.card-description'
					)
				},
				WorkAlongInformation: {
					CardTitle: marker('home.about-us-section.cards.work-along-information.card-title'),
					CardDescription: marker('home.about-us-section.cards.work-along-information.card-description')
				}
			}
		}
	}
};
